<template>
  <el-dialog
    title="添加其他成本"
    :visible.sync="visible"
    width="400px"
    :close-on-click-modal="false"
    @close="$emit('update:show', false)"
  >
    <el-form
      :model="model"
      :rules="rules"
      ref="form"
      label-width="60px"
      size="small"
    >
      <el-form-item label="名称" prop="name">
        <el-input
          v-model="model.name"
          :disabled="model.category == 6 || model.category == 7"
        ></el-input>
      </el-form-item>
      <el-form-item
        :label="model.category == 6 || model.category == 7 ? '总额' : '价格'"
        prop="price"
      >
        <el-input-number
          v-model="model.price"
          :precision="2"
          class="long"
        ></el-input-number>
        <div
          class="text-danger font-12"
          v-if="model.category == 6 || model.category == 7"
        >
          钻头根据结算月的工时占比自动均摊
        </div>
      </el-form-item>
      <el-form-item
        label="数量"
        prop="number"
        v-if="model.category != 6 && model.category != 7"
      >
        <el-input-number
          class="long"
          v-model="model.number"
          :step="1"
          step-strictly
        ></el-input-number>
      </el-form-item>

      <el-form-item class="mb-0">
        <el-button size="small" type="primary" @click="submitForm"
          >确 定</el-button
        >
        <el-button size="small" @click="visible = false">取 消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { drillCostNew } from '@/service/getData'
export default {
  components: {},
  props: {
    model: {
      type: Object,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
      if (!this.visible) {
        this.$refs.form.resetFields()
      }
    },
  },
  data() {
    return {
      visible: this.show,
      rules: {
        name: [{ required: true, message: '请填写成本名称' }],
        price: [{ required: true, message: '请填写价格' }],
        number: [{ required: true, message: '请填写数量' }],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          let data = this.model
          let res = await drillCostNew(data)
          if (res.code == 0) {
            this.$emit('callback', res.data)
            this.visible = false
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
  },
}
</script>